import { useId } from "react";

import { colors } from "../design-tokens/colors";

import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;

  fillPercentage?: number;
} & React.SVGProps<SVGSVGElement>;

export const UploadIcon: React.FC<Props> = ({
  color,
  fillPercentage,
  ...svgProps
}) => {
  const iconId = useId();
  const gradientId = `download-icon-${iconId.replace(/[^a-z0-9]/gi, "-")}-${
    fillPercentage ?? "default"
  }`;

  return (
    <SVG
      viewBox="0 0 27 26"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 26)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" x2="0%" y1="100%" y2="0%">
          <stop
            offset={`${fillPercentage ?? 100}%`}
            stopColor={color ?? svgProps.stroke ?? "currentColor"}
          />
          {typeof fillPercentage !== "undefined" && (
            <stop
              offset={`${fillPercentage ?? 100}%`}
              stopColor={colors.black()}
              stopOpacity={0.2}
            />
          )}
        </linearGradient>
      </defs>

      <path
        stroke={`url(#${gradientId})`}
        d="M12 14v11M8.4 17.6 12 14l3.7 3.7M22.3 15a5.6 5.6 0 1 0-6.8-8.7 7.4 7.4 0 1 0-13 6.7"
      />
    </SVG>
  );
};
